export const splitAndAddRemainder = (num: number, divisor: number) => {
  const base = Math.floor(num / divisor);
  const remainder = num % divisor;
  const result = Array(divisor).fill(base);

  result[divisor - 1] += remainder;
  return result;
};
